import { render, staticRenderFns } from "./moreList.vue?vue&type=template&id=5bc6c571&scoped=true&"
import script from "./moreList.vue?vue&type=script&lang=js&"
export * from "./moreList.vue?vue&type=script&lang=js&"
import style0 from "./moreList.vue?vue&type=style&index=0&id=5bc6c571&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc6c571",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bc6c571')) {
      api.createRecord('5bc6c571', component.options)
    } else {
      api.reload('5bc6c571', component.options)
    }
    module.hot.accept("./moreList.vue?vue&type=template&id=5bc6c571&scoped=true&", function () {
      api.rerender('5bc6c571', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bill/moreList.vue"
export default component.exports